import React, { FC } from 'react';
import CircularProgress from '@mui/material/CircularProgress';

interface LoadingProps {
  size?: number;
  color?: string;
  ariaLabel?: string;
}

const Loading: FC<LoadingProps> = ({ size = 20, color = '#f1f4f6', ariaLabel = 'Loading' }) => (
  <CircularProgress size={size} style={{ color }} aria-label={ariaLabel} />
);

export default Loading;
